import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_DATASETS',
  'FETCH_DATASETS_START',
  'FETCH_DATASETS_SUCCESS',
  'FETCH_DATASETS_ERROR',
]);
